import { getSharedRefreshPromise } from './auth-guard';
import { tokenManager } from './token-manager';

/**
 * The Authorization header for the next request, refreshed first when the
 * access token has expired (it saves a 401 round trip). Null when there is no
 * session to refresh, or when the refresh failed: the caller sends the request
 * without it and handles the 401. Shared by the axios interceptor and by the
 * requests that cannot go through axios, such as a streamed fetch.
 */
export async function getFreshAuthorizationHeader(): Promise<string | null> {
  const header = tokenManager.getAuthorizationHeader();
  if (header && !tokenManager.isTokenExpired()) return header;
  if (!tokenManager.getRefreshToken()) return null;

  console.log('[AXIOS] No valid access token, attempting refresh before request.');
  const refreshResult = await getSharedRefreshPromise();
  // Token clearing is handled by refreshAccessToken for auth failures; network
  // errors intentionally keep the tokens for a later retry.
  return refreshResult.success ? tokenManager.getAuthorizationHeader() : null;
}
